export default __webpack_public_path__ + "static/media/homepage.5912d850.png";